import superagent from 'superagent';
import * as c from '../constants/actionTypes';
import * as config from '../config/config';
import calculatePrice from '../util/calculatePrice';

export function uploadPaper_Request() {
  return {
    type: c.UPLOAD_PAPER_REQUEST,
    loading: true
  }
}

export function UpdateExtrasDifference(body){
  return {
    type: c.UPDATE_EXTRAS_DIFFERENCE,
    body: body
  }
}

export function updatePaperInputLocal(key,body){
  return {
    type: c.UPDATE_PAPER_INPUT,
    loading: false,
    key: key,
    body: body
  }
}

export function updateStep2local(level, time_limit){
  return {
    type: c.UPDATE_STEP_2,
    loading: false,
    editor_level: level,
    time_limit: time_limit
  }
}

export function setSessionProps(body){
  return {
    type: "UPDATE_SESSION_STEP2",
    loading: false,
    body: body
  }
}

export function setSession1Props(body){
  return {
    type: "UPDATE_SESSION_STEP1",
    loading: false,
    body: body
  }
}


export function getSession1(cb){
  return function(dispatch) {
    superagent
    .get(config.BASE + 'api/papersession')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
      } else {
        console.log('checking session');
        console.log(res);
        dispatch(setSession1Props(res));
        if(cb) {
          cb(res);
        }
      }
    })
  }
}

export function initAbandonedSession(docId, cb) {
  return function(dispatch) {
    superagent.get(config.BASE + 'api/returntocart/'+docId)
    .withCredentials()
    .end((err, res) => {
      if(err) {
        console.log("failed to re-init abandon");
        cb(false);
      } else {
        dispatch(setSession1Props(res));
        cb(true);
      }
    });
  }
}

export function getSession2(ch){
  return function(dispatch) {
    // sending step=2 to initiate abandon
    superagent
    .get(config.BASE + 'api/papersession?step=2')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
      } else {
        console.log('checking session');
        console.log(res);
        dispatch(setSessionProps(res));
      }
    })
  }
}

export function updateStep2(editor_level, time_limit){
  return function(dispatch) {
    console.log("updating paper input");
    console.log(editor_level);
    console.log(time_limit);
    dispatch(updateStep2local(editor_level,time_limit))
    let temp_body = {
      editor_level : editor_level,
      time_limit: time_limit
    };
    superagent
    .post(config.BASE + 'api/papersession')
    .send(temp_body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))

      } else {
        console.log("SUCCESS UPDATING step 2 session: ", res.body);

      }
    })
  }
}


export function updatePaperInput(key,body){
  return function(dispatch) {
    console.log("updating paper input");
    dispatch(updatePaperInputLocal(key,body))
    let temp_body = {
      key : key,
      body: body
    }
    console.log(temp_body);
    superagent
    .post(config.BASE + 'api/papersession')
    .send(temp_body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        // dispatch(uploadSpecialInstructionsFile_Failure(err))
      } else {
        console.log("SUCCESS UPDATING Paper input: ", res.body);
        // dispatch(uploadSpecialInstructionsFile_Success(res.body));
      }
    })
  }
}

export function clearPaperSessionLocal() {
  return {
    type: c.CLEAR_PAPER_SESSION,
    body: {},
    loading: false
  }
}
export function clearPaperSession(cb) {
  return function(dispatch) {
    //dispatch(clearPaperSessionLocal())
    superagent
    .delete(config.BASE + 'api/papersession')
    .send()
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
      } else {
        if(cb) {
          cb();
        }
      }
    })
  }
}

export function uploadPaper_SuccessLocal(body) {
  return {
    type: c.UPLOAD_PAPER_SUCCESS,
    body: body,
    loading: false
  }
}

export function uploadPaper_Success(body) {
  return function(dispatch) {
    dispatch(uploadPaper_SuccessLocal(body))
    superagent
    .post(config.BASE + 'api/papersession')
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        // dispatch(uploadSpecialInstructionsFile_Failure(err))
      } else {
        console.log("SUCCESS UPDATING Session", res.body);
        // dispatch(uploadSpecialInstructionsFile_Success(res.body));
      }
    })
  }
}


export function uploadPaper_Failure(error) {
  return {
    type: c.UPLOAD_PAPER_FAILURE,
    error: error,
    loading: false
  }
}


export function downsell_time_limit(time_limit){
  return {
    type: c.DOWNSELL_TIME_LIMIT,
    loading: false,
    time_limit: time_limit,
  }
}

export function downsell_editor_level(editor_level){
  return {
    type: c.DOWNSELL_EDITOR_LEVEL,
    loading: false,
    editor_level: editor_level,
  }
}


export function upsell_editor_level(editor_level){
  return {
    type: c.UPSELL_EDITOR_LEVEL,
    loading: false,
    editor_level: editor_level,
  }
}
export function upsell_time_limit(time_limit){
  return {
    type: c.UPSELL_TIME_LIMIT,
    loading: false,
    time_limit: time_limit,
  }
}

export function updateStep3(extra, extras_array){
  return function(dispatch) {
    dispatch(updateStep3Local(extra, extras_array))
    let temp_body = {
      extras : extras_array,
    };
    superagent
    .post(config.BASE + 'api/papersession')
    .send(temp_body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))

      } else {
        console.log("SUCCESS UPDATING step 3 session: ", res.body);

      }
    })
  }
}

export function updateStep3Local(extra, extras_array) {
  return {
    type: c.UPDATE_STEP_3,
    loading: false,
    extra: extra,
    extras_array: extras_array
  }
}

export function updateSpecialInstruction(textvalue){
  return {
    type: c.UPDATE_STEP_3_SPECIAL_TEXT,
    loading: false,
    special_text: textvalue
  }
}

export function removeExtra(extra, extras_array){
  return {
    type: c.REMOVE_EXTRA,
    loading: false,
    extra: extra,
    extras_array: extras_array
  }
}

export function uploadSpecialInstructionsCopy(file){
  return {
    type: c.UPDATE_STEP_3_UPLOAD,
    loading: false,
    file_name: file.name
  }
}
export function uploadSpecialInstructionsFile_Request(file){
  return {
    type: c.UPLOAD_SPECIAL_INSTUCTIONS_REQUEST,
    loading: true,
    file_name: file.name
  }
}
export function uploadSpecialInstructionsFile_Failure(){
  return {
    type: c.UPLOAD_SPECIAL_INSTUCTIONS_FAILURE,
    loading: false,
  }
}
export function uploadSpecialInstructionsFile_Success(file){
  return {
    type: c.UPLOAD_SPECIAL_INSTUCTIONS_SUCCESS,
    loading: false,
    file: file
  }
}
export function updateSpecialInstructionFile(paper){
  return function(dispatch) {
    console.log("inside action:", paper);
    dispatch(uploadSpecialInstructionsFile_Request(paper))
    dispatch(uploadSpecialInstructionsCopy(paper))
    superagent
    .post(config.BASE + 'api/instructions')
    .withCredentials()
    .attach('file_instructions', paper)
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        dispatch(uploadSpecialInstructionsFile_Failure(err))
      } else {
        console.log("SUCCESS UPDATING SPECIAL INSTURCTIONS FILE: ", res.body);
        dispatch(uploadSpecialInstructionsFile_Success(res.body));
      }
    })
  }
}

export function storeWordCount(wordCount, docId) {
  return function(dispatch) {
    superagent
    .post(config.BASE + 'api/paper/words')
    .withCredentials()
    .set('Content-Type', 'application/json')
    .send({'word_count': wordCount, 'doc_id': docId})
    .end((err, res) => {
      if(err) {
        alert("An error occured, please contact us at info@proofreadingmanuscripts.com");
      } else {
        // all good.
      }
    })
  }
}

export function uploadPaper(paper, pricing, basepaper){
  return function(dispatch) {
    dispatch(uploadPaper_Request())
    console.log(paper)
    console.log(basepaper);
    console.log("Inside upload apper");
    superagent
    .post(config.BASE + 'api/paper')
    .withCredentials()
    .attach('file', paper[0])
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        alert("Upload failed. Please re-save your document as a Microsoft Word or Pages file. Chat with us for help.");
        dispatch(uploadPaper_Failure(err))
      } else {
        var obj = {}
        obj.paper = basepaper;
        obj.paper.word_count = res.body.data.word_count;
        if(!obj.paper.word_count || obj.paper.word_count < 1){
          alert("Please enter word count!");
        }
        obj.paper.doc_name = res.body.data.doc_name;
        // obj.paper.editor_level = 'gold';  // set in server side now
        // obj.paper.time_limit = '7'; // set in server side now
        obj.pricing = pricing;
        var data = calculatePrice(obj);
        dispatch(uploadPaper_Success(res.body));
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/paper.js